import { ApolloError, useQuery } from '@apollo/client'
import { RESIGNED_EMPLOYEE_OVERVIEW_TAB_DATA } from '../ContractQueries'
import { ResignedEmployeeOverviewTabDataQuery, ResignedEmployeeOverviewTabDataQueryVariables, Country } from '../../../types'

export default (
  employeeId: number,
  country: Country,
): { data: ResignedEmployeeOverviewTabDataQuery | undefined; error: ApolloError | undefined; loading: boolean } => {
  const { data, error, loading } = useQuery<ResignedEmployeeOverviewTabDataQuery, ResignedEmployeeOverviewTabDataQueryVariables>(
    RESIGNED_EMPLOYEE_OVERVIEW_TAB_DATA,
    {
      variables: {
        employeeId: employeeId,
        country,
      },
    },
  )

  return { data, error, loading }
}
